import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import PhotoAlbum from "react-photo-album";
import photosFeteFinAnnee from "../../../__params/tab-pages/animations/tab-fetefinannee";
import MenuSaison from "../../../components/menus/m-saison";
import MenuBreadcrumbEvents from "../../../components/menus/m-breadcrumb";
import { useNavHeight } from "../../../__utils/context/navheightprovider";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// import optional lightbox plugins
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const SoireeClub = () => {
  const [indexPhoto, setIndexPhoto] = useState(-1);
  const [tabImages, setTabImages] = useState([]);

  const { navbarHeight, sideNavHeight, breadNavHeight } = useNavHeight();
  //
  /* Tri de la table des photos de fin d'année en ordre décroissant */
  //
  const photosSorted = photosFeteFinAnnee.sort((a, b) => b.id - a.id);
  //
  /* Récupération des saisons existant dans la table photos de fin d'année */
  //
  const tabSaison = [];
  let season = "";

  photosSorted.map((saison) => {
    if (saison.season !== season) {
      season = saison.season;
      /* La propriété season est nécessaire pour compatibilité avec les autres tables utilisant MenuSaison */
      tabSaison.push({ id: saison.season, season: saison.season });
    }
    return {
      tabSaison,
    };
  });
  /* FIN - Récupération des saisons existant dans la table photos soirée club */

  const handlePhotoClicked =
    (season) =>
    ({ index }) => {
      // Récupérer les photos de la bonne saison, bonne édition

      // Filtrer les images pour la date "08/02/2025"
      const imagesClicked = photosSorted
        .filter((saison) => saison.season === season)
        .flatMap((session) => session.images);
      // setTabImages(imagesClicked.shift());
      setTabImages(imagesClicked);

      setIndexPhoto(index);
    };

  return (
    <main role="main" className="mc-fond-clubhouse" id="mcTopPage">
      <Container fluid className="gx-0">
        <Row className="gx-0">
          <Col
            xs={12}
            md={3}
            className="gx-0"
            style={{
              position: "sticky",
              top: navbarHeight,
              zIndex: "1000",
            }}
          >
            <MenuSaison saisons={tabSaison} />
          </Col>
          <Col xs={12} md={9} className="gx-0">
            {/***************************** menu breadcrumb */}
            <MenuBreadcrumbEvents />
            {/************************** Partie Soirée Club */}
            <Card bg="dark" className="m-2 border-0">
              <Card.Header className="mc-rampart mc-rfs-2 m-3 text-primary rounded-0 text-center bg-secondary-subtle">
                SOIRÉES CLUB
              </Card.Header>
            </Card>
            {/************************** Partie Soirée Club */}
            {photosSorted.map((saison) => {
              return (
                <div key={saison.id}>
                  <Card bg="transparent" className="m-2 border-0">
                    <span
                      className="mc-marker"
                      style={{
                        top: -(navbarHeight + sideNavHeight + breadNavHeight),
                      }}
                      id={`saison${saison.season}`}
                    ></span>
                    <Card.Body
                      style={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                      }}
                      className="my-4 mx-2 p-2 rounded"
                    >
                      <Card.Header
                        className="mc-rampart mc-rfs-3 m-2 text-primary rounded"
                        style={{
                          backgroundColor: "rgba(255, 255, 255, 1)",
                        }}
                      >
                        {`SAISON ${saison.season}`}
                      </Card.Header>
                    </Card.Body>
                    <Card.Body
                      style={{
                        backgroundColor: "rgba(255, 255, 255, 0.7)",
                      }}
                      className="m-2 p-4"
                    >
                      <PhotoAlbum
                        layout="rows"
                        photos={saison.images}
                        onClick={handlePhotoClicked(saison.season)}
                      />
                    </Card.Body>
                  </Card>
                </div>
              );
            })}
            <Lightbox
              slides={tabImages}
              open={indexPhoto >= 0}
              index={indexPhoto}
              close={() => setIndexPhoto(-1)}
              // enable optional lightbox plugins
              plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
            />
          </Col>
        </Row>
      </Container>
    </main>
  );
};

export default SoireeClub;
